import axios from 'axios';
import TokenService from './token.service';
import { fetchUser } from 'store/UserSession/features';

import { store } from 'store';

const BASE_URL =
  'https://pixlink-dev-api.mangodesert-d5246498.francecentral.azurecontainerapps.io/'
//'https://prod.pixlinksweb.com/pixlink';
//'http://localhost:8080/';
const axiosPixLink = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

axiosPixLink.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();

    if (token) {
      config.headers['authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosPixLink.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalReq = error?.config;
    if (
      (error.response && error.response.status === 403) ||
      (error.response && error.response.status === 401)
    ) {
      // auto logout if 403 Forbidden response returned from api
      TokenService.removeUser();
      store.dispatch(fetchUser(null));

      originalReq._retry = true;
    }
    return Promise.reject(error);
  }
);

export default axiosPixLink;
